import * as React from 'react'

import './activity_slide.scss'

import { IProps } from './interface'

class ActivitySlide extends React.Component<IProps> {
    public render = () => {
        const { url } = this.props
        return (
            <div className="activity-slide" style={{ backgroundImage: `url("${url}")` }} />
        )
    }
}

export {
    ActivitySlide
}


// WEBPACK FOOTER //
// ./src/components/common/activity_slide/activity_slide.tsx